import {
  Select,
  SelectContent,
  SelectGroup,
  SelectTrigger,
  SelectItem,
} from '@/components/ui/select';
import ColoredDot from '@/domain/termine/components/ColorPicker/ColorDot';
import {
  TooltipProvider,
  Tooltip,
  TooltipTrigger,
  TooltipContent,
} from '@/components/ui/tooltip';
import {
  markierungGermanMap,
  markierungMapper,
} from '@/domain/termine/shared/types/Markierung';

const enToDeMap: Record<string, string> = Object.entries(
  markierungGermanMap,
).reduce((acc, [de, en]) => ({ ...acc, [en]: de }), {});

const colorEntries = Object.entries(markierungMapper);

export default function ColorPicker({
  value,
  onChange,
}: {
  value: string;
  onChange: (markierung: string) => void;
}) {
  return (
    <TooltipProvider>
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger className="w-20 border-neutrals-300">
          <div className="flex items-center">
            <ColoredDot
              color={markierungMapper[value]?.base}
              title={enToDeMap[value]}
            />
          </div>
        </SelectTrigger>
        <SelectContent className="border-none overflow-visible">
          <SelectGroup>
            <div className="grid grid-cols-3">
              {colorEntries.map(([name, { base }]) => {
                const isSelected = value === name;
                return (
                  <SelectItem key={name} value={name} showIndicator={false}>
                    <Tooltip>
                      <TooltipTrigger asChild>
                        <span
                          className={
                            'rounded-full w-6 h-6 flex items-center justify-center' +
                            (isSelected ? ' ring-2 ring-black' : '')
                          }>
                          <ColoredDot color={base} />
                        </span>
                      </TooltipTrigger>
                      <TooltipContent side="bottom">
                        {enToDeMap[name]}
                      </TooltipContent>
                    </Tooltip>
                  </SelectItem>
                );
              })}
            </div>
          </SelectGroup>
        </SelectContent>
      </Select>
    </TooltipProvider>
  );
}
